<template>
  <div v-if="user">
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-account
      </v-icon>
        <span class="px-2">
            {{ $t("Account Information") }}
        </span>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="$router.go(-1)" class="mx-1">
            {{ $t("Back") }}
          <v-icon right dark> mdi-keyboard-return </v-icon>
        </v-btn>
        <v-btn
          v-if="!isRouteMaking"
          depressed
          color="primary"
          @click="editUser"
          class="mx-1"
        >
          {{ $t("Edit") }}
          <v-icon right dark> mdi-pencil </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="user" class="mt-5">
        <!-- display user info -->
        <v-row>
          <v-col cols="12" md="3">
            <avatar-image-component :edit="false" :avatarUrl="user.avatar" :user="user.id"></avatar-image-component>
          </v-col>
          <v-row class="mx-2">
            <v-col cols="12" md="6">
              <p class = "font-weight-bold">
                {{ $t("User Name") }}
              </p>
              <div class="mt-4">
                <p>{{ user.name }}</p>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <p class = "font-weight-bold">
                {{ $t("Email") }}
              </p>
              <div class="mt-4">
                <p>{{ user.email }}</p>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <p class = "font-weight-bold">{{ $t("Registered") }}</p>
              <div class="mt-4">
                <p>{{ user.created_at | moment("LL") }} - {{ user.created_at | moment("LT") }}</p>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <p class = "font-weight-bold">{{ $t("Wallet") }}</p>
              <div class="mt-4">
                <p>{{ user.wallet }}</p>
              </div>
            </v-col>
          </v-row>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <p class = "font-weight-bold">{{ $t("Role") }}</p>
            <div class="mt-4">
              <v-chip
                color="primary"
                dark
              >
                {{ $te(getRoleValue(user.role)) ? $t(getRoleValue(user.role)) : getRoleValue(user.role) }}
                <v-icon class="mx-2">
                  {{ getIconOfRole(user.role) }}
                </v-icon>
              </v-chip>
            </div>
          </v-col>
          <v-col cols="12" md="9">
              <v-row>
                <v-col cols="12" md="6">
                  <p class = "font-weight-bold">{{ $t("Status") }}</p>
                  <div class="mt-4">
                    <v-chip
                      :color="getStatusColor(user.status_id)"
                      dark
                    >
                      {{ $t(getStatusValue(user.status_id)) }}
                      <v-icon class="mx-2">
                        {{ getIconOfStatus(user.status_id) }}
                      </v-icon>
                    </v-chip>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <p class = "font-weight-bold">
                    {{ $t("Preferred Payment Method") }}
                  </p>
                  <div class="mt-4">
                  <v-chip
                    :color="getRedemptionPreferenceColor(user.redemption_preference)"
                    dark
                  >
                    {{ $t(getRedemptionPreferenceValue(user.redemption_preference)) }}
                    <v-icon class="mx-2">
                      {{ getIconOfRedemptionPreference(user.redemption_preference) }}
                    </v-icon>
                  </v-chip>
                  </div>
                </v-col>

              </v-row>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>

    <!-- display driver documents -->
    <v-card v-if="user.role == 2 && user.driver_information" class="mt-5">
      <v-card-title>
        <v-icon color="primary">
          mdi-information
        </v-icon>
        <span class="px-2">
            {{ $t("Personal Information") }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <p class = "font-weight-bold">
                {{ $t("First Name") }}
            </p>
            <div class="mt-4">
              <p>{{ user.driver_information.first_name }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <p class = "font-weight-bold">
                {{ $t("Last Name") }}
            </p>
            <div class="mt-4">
              <p>{{ user.driver_information.last_name }}</p>
            </div>
          </v-col>
          <!-- phone_number -->
          <v-col cols="12" md="4">
            <p class = "font-weight-bold">
                {{ $t("Phone Number") }}
            </p>
            <div class="mt-4">
              <p>{{ user.driver_information.phone_number }}</p>
            </div>
          </v-col>
          <!-- address -->
          <v-col cols="12" md="4">
            <p class = "font-weight-bold">
                {{ $t("Address") }}
            </p>
            <div class="mt-4">
              <p>{{ user.driver_information.address }}</p>
            </div>
          </v-col>
          <!-- email -->
          <v-col cols="12" md="4">
            <p class = "font-weight-bold">
                {{ $t("Communication Email") }}
            </p>
            <div class="mt-4">
              <p>{{ user.driver_information.email }}</p>
            </div>
          </v-col>
          <!-- license -->
          <v-col cols="12" md="4">
            <p class = "font-weight-bold">
                {{ $t("License") }}
            </p>
            <div class="mt-4">
              <p>{{ user.driver_information.license_number }}</p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Driver documents -->
    <v-card v-if="user.role == 2 && getDriverDocuments().length > 0" class="mt-5">
      <v-card-title>
        <v-icon color="primary">
          mdi-file-document
        </v-icon>
        <span class="px-2">
            {{ $t("Driver Documents") }}
        </span>
      </v-card-title>
      <v-card-text
        v-for="(document, index) in getDriverDocuments()"
        :key="document.id"
        :style="isDocRejected(document) ? 'border: 2px solid #ef5350; border-radius: 8px; margin: 12px; background: rgba(239, 83, 80, 0.04);' : (document.has_pending_replacement ? 'border: 2px solid #F5A114; border-radius: 8px; margin: 12px; background: rgba(245, 161, 20, 0.04);' : '')"
      >
        <!-- Pending Replacement Badge & Action Button -->
        <div v-if="document.has_pending_replacement" class="mb-3 d-flex align-center flex-wrap">
          <v-chip color="warning" class="font-weight-bold me-3 mb-1" small>
            <v-icon left x-small>mdi-clock-outline</v-icon>
            {{ $t('update_pending_review') || 'تحديث قيد المراجعة' }}
          </v-chip>
          <v-btn color="warning" depressed small class="mb-1" @click="openReviewModal(document.pending_request_id)">
            <v-icon left small>mdi-eye</v-icon>
            {{ $t('review_update') || 'مراجعة التحديث' }}
          </v-btn>
        </div>

        <div v-if="isDocRejected(document)" class="mb-2">
          <v-chip color="error" class="font-weight-bold" small>
            <v-icon left x-small>mdi-close-circle</v-icon>
            {{ $t('rejected') || 'مرفوض' }}
          </v-chip>
        </div>
        <v-row>
          <!-- Document Image -->
          <v-col cols="12" md="3">
            <div class="driver-document">
              <v-avatar rounded size="120" @click="viewDocumentImage(document)">
                <v-img :src="getDocumentImage(document)" alt="Document Image"></v-img>
              </v-avatar>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <p class = "font-weight-bold">
                {{ $t("Document Name") }}
            </p>
            <div class="mt-4">
              <p>{{ document.document_name }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <p class = "font-weight-bold">
                {{ $t("Document Number") }}
            </p>
            <div class="mt-4">
              <p>{{ document.document_number }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <p class = "font-weight-bold">
                {{ $t("Expiry Date") }}
            </p>
            <div class="mt-4">
              <p>{{ document.expiry_date | moment("LL") }}</p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Document Archive Section -->
    <v-card v-if="user.role == 2 && documentArchive && documentArchive.length > 0" class="mt-5">
      <v-card-title>
        <v-icon color="primary" class="me-2">mdi-history</v-icon>
        <span>{{ $t("document_archive") || "أرشيف المستندات" }}</span>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $t("Document Name") }}</th>
                <th class="text-left">صورة المستند</th>
                <th class="text-left">{{ $t("Document Number") }}</th>
                <th class="text-left">{{ $t("Expiry Date") }}</th>
                <th class="text-left">الحالة</th>
                <th class="text-left">التاريخ</th>
                <th class="text-left">تمت المراجعة بواسطة</th>
                <th class="text-left">سبب الرفض</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in documentArchive" :key="item.record_type + '-' + item.id">
                <td class="font-weight-bold">{{ item.document_name }}</td>
                <td>
                  <v-avatar rounded size="50" class="my-1 cursor-pointer" @click="viewImageUrl(item.remote_file_path)">
                    <v-img :src="getImageUrl(item.remote_file_path)" alt="Document Archive"></v-img>
                  </v-avatar>
                </td>
                <td>{{ item.document_number || '-' }}</td>
                <td>{{ item.expiry_date ? (item.expiry_date | moment("LL")) : '-' }}</td>
                <td>
                  <v-chip v-if="item.status === 'replaced'" color="info" small class="font-weight-bold">
                    <v-icon left x-small>mdi-history</v-icon>
                    مستند سابق (تم استبداله)
                  </v-chip>
                  <v-chip v-else-if="item.status === 'rejected'" color="error" small class="font-weight-bold">
                    <v-icon left x-small>mdi-close-circle</v-icon>
                    مرفوض
                  </v-chip>
                  <v-chip v-else color="grey" small>{{ item.status }}</v-chip>
                </td>
                <td>{{ item.date ? (item.date | moment("LL")) : '-' }}</td>
                <td>{{ item.reviewed_by || '-' }}</td>
                <td class="error--text font-weight-medium">{{ item.rejection_reason || '-' }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <!-- Approve or Reject Driver -->
    <v-card v-if="user.role == 2 && user.status_id == 4" class="mt-5">
      <v-card-title>
        <v-icon color="primary">
          mdi-account-check
        </v-icon>
        <span class="px-2">
            {{ $t("Approve or Reject Driver") }}
        </span>
      </v-card-title>
      <v-card-text>
        <div class="d-flex justify-space-between mb-6 bg-surface-variant">
            <v-btn
              depressed
              color="success"
              @click="approveDriver"
              class="mx-1"
            >
              {{ $t("Approve") }}
              <v-icon right dark> mdi-check </v-icon>
            </v-btn>

            <v-btn
              depressed
              color="error"
              @click="rejectDriver"
              class="mx-1"
            >
                {{ $t("Reject") }}
              <v-icon right dark> mdi-close </v-icon>
            </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <!-- Rejected Driver Info & Return to Review -->
    <v-card v-if="user.role == 2 && user.status_id == 5" class="mt-5">
      <v-card-title class="error white--text py-2">
        <v-icon color="white" class="me-2">mdi-account-cancel</v-icon>
        <span>بيانات رفض طلب السائق</span>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" md="6">
            <strong>سبب الرفض العام:</strong>
            <p class="error--text font-weight-medium mt-1 mb-0">
              {{ (user.driver_information && (user.driver_information.rejection_reason || user.driver_information.response)) || 'لا يوجد سبب محدد' }}
            </p>
          </v-col>
          <v-col cols="12" md="3" v-if="user.driver_information && user.driver_information.rejected_at">
            <strong>تاريخ الرفض:</strong>
            <p class="mt-1 mb-0">{{ user.driver_information.rejected_at | moment("LL") }} - {{ user.driver_information.rejected_at | moment("LT") }}</p>
          </v-col>
          <v-col cols="12" md="3" v-if="user.driver_information && user.driver_information.rejected_by_user">
            <strong>تم الرفض بواسطة:</strong>
            <p class="mt-1 mb-0">{{ user.driver_information.rejected_by_user.name }}</p>
          </v-col>
          <v-col cols="12" class="mt-3" v-if="user.driver_information && getRejectedDocsSummary(user.driver_information.rejected_documents).length > 0">
            <strong>المستندات المرفوضة:</strong>
            <div class="mt-2">
              <v-chip
                v-for="(rd, idx) in getRejectedDocsSummary(user.driver_information.rejected_documents)"
                :key="idx"
                color="error"
                outlined
                small
                class="me-2 mb-1 font-weight-bold"
              >
                <v-icon left x-small>mdi-file-cancel</v-icon>
                {{ rd.name || rd }}
              </v-chip>
            </div>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <v-btn color="warning" depressed @click="returnDriverToReview">
          <v-icon left>mdi-restore</v-icon>
          إعادة الطلب إلى قائمة قيد المراجعة
        </v-btn>
      </v-card-text>
    </v-card>

    <!-- Custom Rejection Dialog with Document Selection -->
    <v-dialog v-model="rejectDialog" max-width="700px" persistent>
      <v-card>
        <v-card-title class="headline error white--text py-3">
          <v-icon color="white" class="me-2">mdi-account-remove</v-icon>
          {{ $t('reject_driver_title') }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert v-if="rejectionError" type="error" dense outlined class="mb-4">
            {{ rejectionError }}
          </v-alert>

          <!-- General Rejection Reason -->
          <v-textarea
            v-model="rejectionReason"
            :label="$t('rejection_reason') + ' *'"
            :placeholder="$t('rejection_reason_placeholder')"
            outlined
            rows="3"
            required
            hide-details="auto"
            class="mb-4"
          ></v-textarea>

          <!-- Rejected Documents Section -->
          <div class="mt-2 mb-2">
            <div class="d-flex align-center justify-space-between mb-1">
              <span class="text-subtitle-1 font-weight-bold primary--text">
                <v-icon color="primary" class="me-1">mdi-file-cancel-outline</v-icon>
                {{ $t('rejected_documents') }}
              </span>
              <v-checkbox
                v-if="user && user.driver_information && user.driver_information.documents && user.driver_information.documents.length > 0"
                v-model="selectAllDocs"
                :label="$t('select_all')"
                hide-details
                dense
                class="mt-0 pt-0"
                @change="toggleSelectAllDocs"
              ></v-checkbox>
            </div>
            <div class="text-caption text--secondary mb-3">
              {{ $t('select_documents_help') }}
            </div>

            <!-- Documents Grid -->
            <div v-if="user && user.driver_information && user.driver_information.documents && user.driver_information.documents.length > 0">
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  v-for="doc in user.driver_information.documents"
                  :key="doc.id"
                >
                  <v-card
                    outlined
                    :style="selectedDocIds.includes(doc.id) ? 'border: 2px solid #ef5350 !important; background: rgba(239,83,80,0.06);' : ''"
                    class="pa-2"
                  >
                    <div class="d-flex align-start">
                      <v-checkbox
                        v-model="selectedDocIds"
                        :value="doc.id"
                        hide-details
                        dense
                        class="mt-0 me-2 pt-0"
                      ></v-checkbox>
                      <div class="flex-grow-1 overflow-hidden">
                        <div class="font-weight-bold text-truncate subtitle-2">
                          {{ doc.document_name }}
                        </div>
                        <div class="text-caption text--secondary text-truncate" v-if="doc.document_number">
                          {{ $t('document_number') }}: {{ doc.document_number }}
                        </div>
                        <div class="text-caption text--secondary" v-if="doc.expiry_date">
                          {{ $t('expiry_date') }}: {{ doc.expiry_date }}
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <v-alert v-else type="info" dense outlined class="mt-2">
              {{ $t('no_documents_uploaded') }}
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions class="pa-4 bg-light">
          <v-btn color="grey darken-1" text @click="rejectDialog = false" :disabled="isSubmittingRejection">
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            depressed
            :loading="isSubmittingRejection"
            :disabled="!rejectionReason || !rejectionReason.trim() || isSubmittingRejection"
            @click="submitDriverRejection"
          >
            <v-icon left>mdi-close</v-icon>
            {{ $t('confirm_rejection') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Document Update Review Comparison Modal -->
    <v-dialog v-model="reviewModal" max-width="850px" persistent>
      <v-card v-if="selectedPendingRequest">
        <v-card-title class="headline warning white--text py-3">
          <v-icon color="white" class="me-2">mdi-file-document-edit-outline</v-icon>
          <span>{{ $t('review_update') || 'مراجعة طلب تحديث المستند' }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="reviewModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5" v-if="selectedPendingRequest.request">
          <v-row>
            <!-- Current Approved Document Column -->
            <v-col cols="12" md="6">
              <div class="pa-3 rounded border" style="background-color: #F8F9FA;">
                <h3 class="subtitle-1 font-weight-bold text-center primary--text mb-3">
                  <v-icon color="primary" class="me-1">mdi-check-circle-outline</v-icon>
                  {{ $t('current_document') || 'المستند الحالي المعتمد' }}
                </h3>
                <div v-if="selectedPendingRequest.request.current_document">
                  <div class="text-center mb-3">
                    <v-avatar rounded size="180" class="elevation-2 cursor-pointer" @click="viewImageUrl(selectedPendingRequest.request.current_document.remote_file_path)">
                      <v-img :src="getImageUrl(selectedPendingRequest.request.current_document.remote_file_path)"></v-img>
                    </v-avatar>
                  </div>
                  <div class="mb-2">
                    <strong>اسم الوثيقة:</strong> {{ selectedPendingRequest.request.current_document.document_name }}
                  </div>
                  <div class="mb-2">
                    <strong>رقم الوثيقة:</strong> {{ selectedPendingRequest.request.current_document.document_number || '-' }}
                  </div>
                  <div class="mb-2">
                    <strong>تاريخ الانتهاء:</strong> {{ selectedPendingRequest.request.current_document.expiry_date || '-' }}
                  </div>
                </div>
                <div v-else class="text-center text--secondary py-6">
                  لا يوجد مستند سابق معتمد لهذا النوع
                </div>
              </div>
            </v-col>

            <!-- New Requested Document Column -->
            <v-col cols="12" md="6">
              <div class="pa-3 rounded border" style="background-color: #FFFBEB; border-color: #F5A114 !important;">
                <h3 class="subtitle-1 font-weight-bold text-center warning--text text--darken-2 mb-3">
                  <v-icon color="warning" class="me-1">mdi-clock-alert-outline</v-icon>
                  {{ $t('new_document') || 'المستند الجديد المطلوب اعتماده' }}
                </h3>
                <div v-if="selectedPendingRequest.request.new_document">
                  <div class="text-center mb-3">
                    <v-avatar rounded size="180" class="elevation-2 cursor-pointer" @click="viewImageUrl(selectedPendingRequest.request.new_document.remote_file_path)">
                      <v-img :src="getImageUrl(selectedPendingRequest.request.new_document.remote_file_path)"></v-img>
                    </v-avatar>
                  </div>
                  <div class="mb-2">
                    <strong>رقم الوثيقة الجديد:</strong> {{ selectedPendingRequest.request.new_document.document_number || '-' }}
                  </div>
                  <div class="mb-2">
                    <strong>تاريخ الانتهاء الجديد:</strong> {{ selectedPendingRequest.request.new_document.expiry_date || '-' }}
                  </div>
                  <div class="mb-2" v-if="selectedPendingRequest.request.requested_at">
                    <strong>تاريخ تقديم الطلب:</strong> {{ selectedPendingRequest.request.requested_at | moment("LL") }}
                  </div>
                  <div class="mb-2">
                    <strong>الحالة:</strong>
                    <v-chip color="warning" small class="font-weight-bold ms-2">
                      تحديث قيد المراجعة
                    </v-chip>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-4 bg-light">
          <v-btn color="grey darken-1" text @click="reviewModal = false" :disabled="isProcessingUpdateAction">
            {{ $t('cancel') || 'إلغاء' }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            depressed
            class="me-2"
            :loading="isProcessingUpdateAction"
            :disabled="isProcessingUpdateAction"
            @click="openUpdateRejectModal"
          >
            <v-icon left>mdi-close</v-icon>
            {{ $t('reject_update') || 'رفض التحديث' }}
          </v-btn>
          <v-btn
            color="success"
            depressed
            :loading="isProcessingUpdateAction"
            :disabled="isProcessingUpdateAction"
            @click="approveDocumentUpdate"
          >
            <v-icon left>mdi-check</v-icon>
            {{ $t('approve_update') || 'اعتماد التحديث' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Rejection Reason Dialog for Document Update -->
    <v-dialog v-model="updateRejectDialog" max-width="550px" persistent>
      <v-card>
        <v-card-title class="headline error white--text py-3">
          <v-icon color="white" class="me-2">mdi-file-cancel</v-icon>
          <span>{{ $t('reject_update_title') || 'رفض تحديث المستند' }}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert v-if="updateRejectError" type="error" dense outlined class="mb-4">
            {{ updateRejectError }}
          </v-alert>
          <v-textarea
            v-model="updateRejectionReason"
            :label="($t('rejection_reason') || 'سبب الرفض') + ' *'"
            placeholder="ادخل سبب رفض تحديث المستند بوضوح..."
            outlined
            rows="3"
            required
            hide-details="auto"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn color="grey darken-1" text @click="updateRejectDialog = false" :disabled="isProcessingUpdateAction">
            {{ $t('cancel') || 'إلغاء' }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            depressed
            :loading="isProcessingUpdateAction"
            :disabled="!updateRejectionReason || !updateRejectionReason.trim() || isProcessingUpdateAction"
            @click="submitDocumentUpdateRejection"
          >
            <v-icon left>mdi-close</v-icon>
            تأكيد الرفض
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import AvatarImageComponent from '../../components/AvatarImageComponent.vue'
import {Keys} from '/src/config.js'
import { getUserRole } from '@/services/AuthService'

export default {
  components: {
    AvatarImageComponent,
    Keys
  },

  computed: {
    isRouteMaking() {
      return getUserRole() === 3;
    }
  },

  data() {
    return {
      user: null,
      user_id: null,
      loading: false,
      rejectDialog: false,
      rejectionReason: '',
      selectedDocIds: [],
      selectAllDocs: false,
      isSubmittingRejection: false,
      rejectionError: '',
      documentArchive: [],
      reviewModal: false,
      selectedPendingRequest: null,
      isProcessingUpdateAction: false,
      updateRejectDialog: false,
      updateRejectionReason: '',
      updateRejectError: '',
    };
  },
  mounted() {
    let id = this.$route.params.user_id || this.$route.query.user;
    if (id != null) {
      this.user_id = id;
      this.fetchUser();
    }
  },
  methods: {
    fetchUser() {
      this.loading = true;
      axios
        .get(`/users/user/${this.user_id}`)
        .then((response) => {
          this.loading = false;
          this.user = response.data;
          console.log(this.user);
          if (this.user && this.user.role == 2) {
            this.fetchDocumentArchive();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({
            title: "Error",
            text: "Error fetching user data",
            type: "error",
          });
          console.log(error);
          //this.$router.go(-1);
        });
    },
    editUser() {
      this.$router.push({
        name: "edit-user",
        params: { user_id: this.user.id },
      });
    },
    userStatus(status) {
      if (status == 1) {
        return "Active";
      } else if (status == 2) {
        return "Pending";
      } else if (status == 3) {
        return "Suspended";
      } else if (status == 4) {
        return "Under Review";
      } else {
        return "Unknown";
      }
    },
    getIconOfRedemptionPreference(redemption_preference)
    {
      if(redemption_preference==2)
      {
        return "mdi-bank";
      }
      else if(redemption_preference==3)
      {
        return "mdi-credit-card";
      }
      else if(redemption_preference==4)
      {
        return "mdi-credit-card-multiple";
      }
      else
      {
        return "mdi-cash";
      }
    },
    getRedemptionPreferenceColor(redemption_preference)
    {
      if(redemption_preference==2)
      {
        return "primary";
      }
      else if(redemption_preference==3)
      {
        return "info";
      }
      else if(redemption_preference==4)
      {
        return "secondary";
      }
      else
      {
        return "success";
      }
    },
    getRedemptionPreferenceValue(redemption_preference)
    {
      if(redemption_preference==2)
      {
        return "Bank";
      }
      else if(redemption_preference==3)
      {
        return "PayPal";
      }
      else if(redemption_preference==4)
      {
        return "Mobile Money";
      }
      else
      {
        return "Cash";
      }
    },
    getStatusColor(status) {
      if (status == 1) {
        return "success";
      } else if (status == 2) {
        return "warning";
      } else if (status == 3) {
        return "error";
      } else if (status == 4) {
        return "info";
      }
    },
    getStatusValue(status) {
      if (status == 1) {
        return "Active";
      } else if (status == 2) {
        return "Pending";
      } else if (status == 3) {
        return "Suspended";
      } else if (status == 4) {
        return "Under Review";
      } else {
        return "Unknown";
      }
    },
    getIconOfStatus(status) {
      if (status == 1) {
        return "mdi-check-circle";
      } else if (status == 2) {
        return "mdi-alert-circle";
      } else if (status == 3) {
        return "mdi-close-circle";
      } else if (status == 4) {
        return "mdi-information-outline";
      } else {
        return "mdi-help-circle";
      }
    },
    getRoleValue(role) {
      if (role == 0) {
        return "Admin";
      } else if (role == 1) {
        return "Customer";
      } else if (role == 2) {
        return "Driver";
      } else if (role == 3) {
        return "Route Making";
      } else {
        return "Unknown";
      }
    },
    getIconOfRole(role) {
      if (role == 0) {
        return "mdi-account-lock";
      } else if (role == 1) {
        return "mdi-account";
      } else if (role == 2) {
        return "mdi-account-tie-hat";
      } else if (role == 3) {
        return "mdi-road-variant";
      } else {
        return "mdi-account-question";
      }
    },
    getDocumentImage(document)
    {
      return Keys.VUE_APP_API_URL + document.remote_file_path;
    },
    viewDocumentImage(document)
    {
      window.open(Keys.VUE_APP_API_URL + document.remote_file_path, '_blank');
    },
    rejectDriver() {
      this.rejectionReason = '';
      this.selectedDocIds = [];
      this.selectAllDocs = false;
      this.rejectionError = '';
      this.rejectDialog = true;
    },
    toggleSelectAllDocs(val) {
      if (val && this.user && this.user.driver_information && this.user.driver_information.documents) {
        this.selectedDocIds = this.user.driver_information.documents.map(d => d.id);
      } else {
        this.selectedDocIds = [];
      }
    },
    submitDriverRejection() {
      if (!this.rejectionReason || !this.rejectionReason.trim()) {
        this.rejectionError = 'سبب الرفض العام مطلوب';
        return;
      }
      this.isSubmittingRejection = true;
      this.rejectionError = '';
      axios
        .post('/drivers/take-action', {
          driver_id: this.user.id,
          reason: this.rejectionReason.trim(),
          action: 2,
          rejected_document_ids: this.selectedDocIds
        })
        .then(() => {
          this.isSubmittingRejection = false;
          this.rejectDialog = false;
          this.$notify({
            title: "Success",
            text: "تم رفض طلب السائق وحفظ المستندات المرفوضة بنجاح",
            type: "success",
          });
          this.fetchUser();
        })
        .catch((error) => {
          this.isSubmittingRejection = false;
          let msg = error.response?.data?.error?.[0] || error.response?.data?.message || "حدث خطأ أثناء رفض الطلب";
          this.rejectionError = msg;
        });
    },
    isDocRejected(doc) {
      if (!this.user || !this.user.driver_information || !this.user.driver_information.rejected_documents) return false;
      const rejected = this.user.driver_information.rejected_documents;
      if (!Array.isArray(rejected)) return false;
      return rejected.some(item => {
        if (typeof item === 'number' || typeof item === 'string') {
          return item == doc.id || item == doc.document_name;
        }
        return item.id == doc.id || item.name == doc.document_name;
      });
    },
    getRejectedDocsSummary(rejectedDocs) {
      if (!rejectedDocs || !Array.isArray(rejectedDocs)) return [];
      return rejectedDocs;
    },
    returnDriverToReview() {
      this.$swal({
        title: "إعادة إلى قيد المراجعة",
        html: "هل أنت تأكد من إعادة هذا السائق إلى قائمة قيد المراجعة؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم، إعادة للمراجعة",
        cancelButtonText: "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          this.takeActionOnDriverServer(this.user.id, null, 3);
        }
      });
    },
    approveDriver() {
      this.$swal({
        title: this.$t("Approve Driver"),
        html: this.$t("Are you sure you want to approve this driver?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes, approve it!"),
        cancelButtonText: this.$t("cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.takeActionOnDriverServer(this.user.id, "Approved", 1);
        }
      });
    },
    takeActionOnDriverServer(user_id, reason, action)
    {
      this.loading = true;
      axios
        .post('/drivers/take-action', {
          driver_id: user_id,
          reason: reason,
          action: action
        })
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: "Success",
            text: "Driver status updated successfully",
            type: "success",
          });
          this.$router.go(-1);
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({
            title: "Error",
            text: "Error taking action",
            type: "error",
          });
          console.log(error);
        });
    },
    fetchDocumentArchive() {
      if (!this.user_id) return;
      axios
        .get(`/admin/drivers/${this.user_id}/document-archive`)
        .then((response) => {
          if (response.data && response.data.archive_history) {
            this.documentArchive = response.data.archive_history;
          }
        })
        .catch((err) => {
          console.error("Fetch document archive error:", err);
        });
    },
    openReviewModal(requestId) {
      if (!requestId) return;
      this.isProcessingUpdateAction = false;
      axios
        .get(`/admin/driver-document-update-requests/${requestId}`)
        .then((response) => {
          if (response.data && response.data.request) {
            this.selectedPendingRequest = response.data;
            this.reviewModal = true;
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Error",
            text: "خطأ في جلب بيانات طلب التحديث",
            type: "error",
          });
        });
    },
    approveDocumentUpdate() {
      if (!this.selectedPendingRequest || !this.selectedPendingRequest.request) return;
      const reqId = this.selectedPendingRequest.request.request_id;
      this.$swal({
        title: this.$t("approve_update") || "اعتماد التحديث",
        html: this.$t("confirm_approve_update") || "هل أنت متأكد من اعتماد المستند الجديد واستبدال المستند الحالي؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم، اعتمد المستند الجديد",
        cancelButtonText: this.$t("cancel") || "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessingUpdateAction = true;
          axios
            .post(`/admin/driver-document-update-requests/${reqId}/approve`)
            .then((res) => {
              this.isProcessingUpdateAction = false;
              this.reviewModal = false;
              this.$notify({
                title: "Success",
                text: this.$t("update_approved_success") || "تم اعتماد تحديث المستند بنجاح",
                type: "success",
              });
              this.fetchUser();
              this.fetchDocumentArchive();
            })
            .catch((err) => {
              this.isProcessingUpdateAction = false;
              let msg = err.response?.data?.error?.[0] || err.response?.data?.message || "حدث خطأ أثناء اعتماد التحديث";
              this.$notify({
                title: "Error",
                text: msg,
                type: "error",
              });
            });
        }
      });
    },
    openUpdateRejectModal() {
      this.updateRejectionReason = '';
      this.updateRejectError = '';
      this.updateRejectDialog = true;
    },
    submitDocumentUpdateRejection() {
      if (!this.selectedPendingRequest || !this.selectedPendingRequest.request) return;
      if (!this.updateRejectionReason || !this.updateRejectionReason.trim()) {
        this.updateRejectError = 'سبب الرفض إجباري';
        return;
      }
      const reqId = this.selectedPendingRequest.request.request_id;
      this.isProcessingUpdateAction = true;
      this.updateRejectError = '';
      axios
        .post(`/admin/driver-document-update-requests/${reqId}/reject`, {
          reason: this.updateRejectionReason.trim()
        })
        .then((res) => {
          this.isProcessingUpdateAction = false;
          this.updateRejectDialog = false;
          this.reviewModal = false;
          this.$notify({
            title: "Success",
            text: this.$t("update_rejected_success") || "تم رفض تحديث المستند",
            type: "success",
          });
          this.fetchUser();
          this.fetchDocumentArchive();
        })
        .catch((err) => {
          this.isProcessingUpdateAction = false;
          let msg = err.response?.data?.error?.[0] || err.response?.data?.message || "حدث خطأ أثناء رفض التحديث";
          this.updateRejectError = msg;
        });
    },
    getImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      return Keys.VUE_APP_API_URL + path;
    },
    viewImageUrl(path) {
      if (!path) return;
      let url = this.getImageUrl(path);
      window.open(url, '_blank');
    },
    getDriverDocuments() {
      if (!this.user) return [];
      let info = this.user.driver_information || this.user.driverInformation;
      if (!info || !info.documents) return [];
      return info.documents;
    }
  },

};
</script>

<style scoped>
.driver-document {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
